module.exports = __webpack_public_path__ + "img/cd-nature-vs-humans.8ac19ef9.jpg";